import AdmissionStatus from '@/utils/shared/constants/admissionStatus';

export default {
  methods: {
    getStatusColor(statusId) {
      switch (statusId) {
        case AdmissionStatus.ReferidoDirectorCSEE:
        case AdmissionStatus.ReferidoRechazado: {
          return `primary-10`;
        }
        case AdmissionStatus.ServicioRelacionadoActivo: {
          return `primary-15`;
        }
        case AdmissionStatus.Asignado:
        case AdmissionStatus.Admitido:
        case AdmissionStatus.Vinculado: {
          return `primary-11`;
        }
        case AdmissionStatus.NoVinculado:
        case AdmissionStatus.Alertas: {
          return `primary-16`;
        }
        case AdmissionStatus.AprobadoRemedioProvisional: {
          return `primary-12`;
        }
        default: {
          return `primary-13`;
        }
      }
    },
  },
};
